import { defineMessages } from 'react-intl';

export const confluenceExtensionMessages: {
	extensionDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	extensionTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	extensionTitlePage: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	// Remove when cleaning up platform_editor_slash_command
	extensionTitle: {
		id: 'editorExtensionLinkCreate.confluencePage.quickInsert.title',
		defaultMessage: 'Create Confluence page',
		description:
			'Title displayed to the user on option in the quick insert menu for activating the extension',
	},
	extensionTitlePage: {
		id: 'editorExtensionLinkCreate.confluencePage.quickInsert.title-page',
		defaultMessage: 'Page',
		description:
			'Title displayed to the user on option in the Create section of the slash command menu for creating a Confluence page',
	},
	extensionDescription: {
		id: 'editorExtensionLinkCreate.confluencePage.quickInsert.description',
		defaultMessage: 'Create and link a new Confluence page',
		description: 'Message that elaborates on the title for the quick insert option',
	},
});
